import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import MultiTierNavigationHeader from "./sections/MultiTierNavigationHeader";
import HeroBanner from "./sections/HeroBanner";
import PromotionalSlider from "./sections/PromotionalSlider";
import Fullwidthvideoembed from "./sections/Fullwidthvideoembed";
import CompanyStatistics from "./sections/CompanyStatistics";
import BusinessDivisions from "./sections/BusinessDivisions";
import IndustriesServed from "./sections/IndustriesServed";
import NewsUpdates from "./sections/NewsUpdates";
import CommercialAlliances from "./sections/CommercialAlliances";
import IndustrialFooter from "./sections/IndustrialFooter";
import Footer from "@/reusable_sections/Footer";
import SectoresServidos from "./sections/SectoresServidos";
import AnimatedHeroCarousel from "./sections/AnimatedHeroCarousel";
export default function HomePage() {
  return <div>
      <Header />
      <MultiTierNavigationHeader />
      <HeroBanner />
      <PromotionalSlider />
      <AnimatedHeroCarousel />
      <Fullwidthvideoembed />
      <CompanyStatistics />
      <BusinessDivisions />
      <SectoresServidos />
      <IndustriesServed />
      <NewsUpdates />
      <CommercialAlliances />
      <IndustrialFooter />
      <Footer />
    </div>;
}